<template>
    <div>
      <MdTitle v-bind:Text="$t('MdPatientInfoBox.PatientFaceSheet')" />
      <div class="flex-container">
        <b-row>
          <b-col lg="3" md="3" sm="12">
            <MdSelect
              v-bind:Label="$tc('Shared.Patient',2)"
              v-bind:Options="PatientsOptions"
              v-bind:Model="PatientModel"
              v-bind:FieldDescription="'patientname'"
              v-bind:FieldCode="'patientcode'"
              v-bind:Multiple="true"
              v-bind:AllowEmpty="true"
              :Input="ChangePatients"/>
          </b-col>
          <b-col lg="3" md="3" sm="12">
           <MdSelect
              v-bind:Label="$tc('Allergy.PatientStatus')"
              v-bind:Options="showOptions"
              v-bind:Model="showPatientIsActiveModel"
              v-bind:FieldDescription="'text'"
              v-bind:FieldCode="'value'" 
              v-bind:Multiple="false"                      
              :Input="ChangeIsActive"
              v-bind:AllowEmpty="false"/>
          </b-col>
          <b-col lg="3" md="3" sm="12"></b-col> 
          <b-col lg="3" md="3" sm="12">
            <div class="text-md-right mt-3">
                <button 
                    v-on:click="LoadPatientFaceSheet"
                    type="button"
                    class="btn btn-primary btn-login mx-2"												
                    id="btnsearchinput">
                    {{ $t('Shared.Search') }}
                </button>
            </div>
          </b-col>   
        </b-row>
      </div>

      <div class="row">
          <div class="col-12 mt-2">
           
                <MdTitle  v-bind:Text="$t('Shared.SearchResult')" 
                          v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>
              <div class="row">
                <div class="col-md-12">
                  <MdTable 
                    v-bind:fields="fields"
                    v-bind:items="items"
                    v-bind:totalRows="totalRows"
                    v-bind:showMessageIsEmpty="ShowMessageIsEmpty"
                    v-bind:currentPage="currentPage"
                    v-bind:perPage="perPage"
                    v-bind:pageOptions="pageOptions"
                    v-bind:refTable="refTable"
                    :pageChanged="pageChanged"
                    :perPageFunction="PerPageFunction">
                  </MdTable>
                </div>
            </div>
          </div>
        </div>

        <div class="space-actions"></div>
        <div class="page-actions">
          <MdButton
            v-bind:Label="$t('Shared.Back')"
            v-bind:ClassProp="'primary btn-login mx-2'"
            v-on:click="reportList"
            v-bind:Name="'btn_ReportList'"/>
          <MdButton
            v-bind:Label="$t('Shared.Report')"
            v-bind:ClassProp="'primary btn-login mx-2'"
            v-on:click="onClickShowReport"
            v-bind:Name="'btn_Print'"/>
            
         <b-dropdown id="dropdown-dropup" dropup :text="$t('Shared.Export')" variant="primary" class="m-2">
						<b-dropdown-item v-on:click="handlePdf('export')">{{$t('Shared.PDF')}}</b-dropdown-item>
						<b-dropdown-item v-on:click="handlePdf('email')">{{$t('Shared.PDFByEmail')}}</b-dropdown-item>
						<b-dropdown-item v-on:click="handleCSV('export')">{{$t('Shared.CSV')}}</b-dropdown-item>
						<b-dropdown-item v-on:click="handleCSV('email')">{{$t('Shared.CSVByEmail')}}</b-dropdown-item>
					</b-dropdown>   

        </div>
      <DxPopup
        :visible="isReportVisible"
        :drag-enabled="true"
        :close-on-outside-click="false"
        :show-close-button="true"
        :show-title="true"
        :hide-on-parent-scroll="true"
        :title="reportTitle"
        @hidden="onHiddenReport"
        :resize-enabled="true"
        shading-color="rgba(0, 0, 0, 0.5)"
        height="94vh"
        width="97vw"
        @showing="onShowing"
      >
        <ReportViewer
          ref="PatientFaceSheetRep"
          :ReportName="'PatientFaceSheet'"
          :ReportTitle="reportTitle"
          :IsAnAPIReport="true"
        />
    </DxPopup>

     <CSVExportHelper
        ref="csvExportHelper"
        v-bind:conformSubject="$t('MdPatientInfoBox.PatientFaceSheet')"
        v-bind:sendEmailAPI="'/PatientFaceSheet/email'"
        v-bind:exportCsvAPI="'/PatientFaceSheet/exportCSV'"
    >    
    </CSVExportHelper>
    </div>
</template>

<script>
    import Vue from 'vue'
    import { DxPopup } from 'devextreme-vue/popup';
    import ShowMessage from '@/components/messages/ShowMessage.js'
    import PatientService from '@/services/patient.service'
    import Utils from '../../../common/utils'
    import DBFunctions from '@/common/DBFunctions.js'
    import { EventBus } from '@/event-bus.js';

    export default Vue.extend({
      name: "PatientFaceSheetRep",
      mixins: [ ShowMessage, Utils, DBFunctions ],
      components: { DxPopup },
      data() {
        return {
          isReportVisible: false,
          reportParams: [],
          showFilters: true,
          PatientsOptions: [],
          PatientModel: '',
          parameter:{
            SearchCriteria:'',
            PageNumber : null,
            PageSize:null,
            Status: true,
          },
          reportTitle: this.$t('MdPatientInfoBox.PatientFaceSheet'),
          paramPatients: '',
          paramIsActive: 'Y',
          fullParam: {
            PageSize:0,
            PageNumber:0
          },
          showOptions: [
            { value: '', text: this.$t('Shared.All') },
            { value: "Y", text:this.$t('Shared.Active') },
            { value: "N", text: this.$t('Shared.Inactive') },
          ],
          showPatientIsActiveModel: {
            "value":"Y",
            "text":this.$t('Shared.Active')
          },
          items: [],         
          fields: [
              { key: 'patientMedicalRecordNo', sortable: true, label: this.$t('PatientFaS.MedicalRecordNo'), class: 'text-rigth' },
              { key: 'patientName', sortable: true, label: this.$t('Shared.PatientName'), class: 'text-rigth' },
              { key: 'patientAcceptedDate', sortable: true, label: this.$t('PatientFaS.AcceptedDate'), class: 'text-rigth' },
              { key: 'patientWeight', sortable: true, label: this.$t('Shared.Weight'), class: 'text-rigth' },
              { key: 'patientHeights', sortable: true, label: this.$t('Shared.Height'), class: 'text-rigth' },
              { key: 'patientAddress', sortable: true, label: this.$t('PatientFaS.Address'), class: 'text-rigth' },
              { key: 'patientCity', sortable: true, label: this.$t('Shared.City'), class: 'text-rigth' },
              { key: 'patientState', sortable: true, label: this.$t('Shared.State'), class: 'text-rigth' },
              { key: 'patientZip', sortable: true, label: this.$t('Shared.Zip'), class: 'text-rigth' },
              { key: 'patientCountry', sortable: true, label: this.$t('Shared.Country'), class: 'text-rigth' },
              { key: 'patientPhone', sortable: true, label: this.$t('PatientFaS.Phone'), class: 'text-rigth' },
              { key: 'patientReferral', sortable: true, label: this.$t('PatientFaS.Referral'), class: 'text-rigth' },
              { key: 'patientPrimaryDiagnosis', sortable: true, label: this.$t('PatientFaS.PrimaryDiagnosis'), class: 'text-rigth' },
              { key: 'patientDiag1', sortable: true, label: this.$t('PatientFaS.Diag1'), class: 'text-rigth' },
              { key: 'patientDiag2', sortable: true, label: this.$t('PatientFaS.Diag2'), class: 'text-rigth' },
              { key: 'patientDiag3', sortable: true, label: this.$t('PatientFaS.Diag3'), class: 'text-rigth' },
              { key: 'patientDOB', sortable: true, label: this.$t('Shared.Dob'), class: 'text-center' },
              { key: 'patientAge', sortable: true, label: this.$t('Shared.Age'), class: 'text-center' },
              { key: 'patientSSN', sortable: true, label: this.$t('PatientFaS.SSN'), class: 'text-rigth' },
              { key: 'patientSex', sortable: true, label: this.$t('Shared.Sex'), class: 'text-center' },
              { key: 'patientMaritalStatus', sortable: true, label: this.$t('PatientFaS.MaritalStatus'), class: 'text-center' },
              { key: 'patientRace', sortable: true, label: this.$t('PatientFaS.Race'), class: 'text-center' },
              { key: 'patientEthnicity', sortable: true, label: this.$t('PatientFaS.Ethnicity'), class: 'text-center' },
              { key: 'patientEyeColor', sortable: true, label: this.$t('PatientFaS.EyeColor'), class: 'text-center' },
              { key: 'patientHairColor', sortable: true, label: this.$t('PatientFaS.HairColor'), class: 'text-center' },
              { key: 'admittingMD', sortable: true, label: this.$t('PatientFaS.AdmittingMD'), class: 'text-rigth' },
              { key: 'doctorPhone', sortable: true, label: this.$t('PatientFaS.DoctorPhone'), class: 'text-rigth' },
              { key: 'emergencyContactName', sortable: true, label: this.$t('PatientFaS.EmergencyContactName'), class: 'text-rigth' },
              { key: 'emergencyContactAddress', sortable: true, label: this.$t('PatientFaS.EmergencyContactAddress'), class: 'text-rigth' },
              { key: 'emergencyContactCity', sortable: true, label: this.$t('PatientFaS.EmergencyContactCity'), class: 'text-rigth' },
              { key: 'emergencyContactState', sortable: true, label: this.$t('PatientFaS.EmergencyContactState'), class: 'text-rigth' },
              { key: 'emergencyContactZIP', sortable: true, label: this.$t('PatientFaS.EmergencyContactZIP'), class: 'text-rigth' },
              { key: 'emergencyContactRelaction', sortable: true, label: this.$t('PatientFaS.EmergencyContactRelation'), class: 'text-rigth' },
              { key: 'emergencyContactPhone', sortable: true, label: this.$t('PatientFaS.EmergencyContactPhone'), class: 'text-rigth' },
              { key: 'primaryContactName', sortable: true, label: this.$t('PatientFaS.PrimaryContactName'), class: 'text-rigth' },
              { key: 'primaryContactAddress', sortable: true, label: this.$t('PatientFaS.PrimaryContactAddress'), class: 'text-rigth' },
              { key: 'primaryContactCity', sortable: true, label: this.$t('PatientFaS.PrimaryContactCity'), class: 'text-rigth' },
              { key: 'primaryContactZip', sortable: true, label: this.$t('PatientFaS.PrimaryContactZip'), class: 'text-rigth' },
              { key: 'primaryContactState', sortable: true, label: this.$t('PatientFaS.PrimaryContactState'), class: 'text-rigth' },
              { key: 'primaryContactPhone', sortable: true, label: this.$t('PatientFaS.PrimaryContactPhone'), class: 'text-rigth' },
              { key: 'primaryContactRelation', sortable: true, label: this.$t('PatientFaS.PrimaryContactRelation'), class: 'text-rigth' },
              { key: 'primaryContactSSN', sortable: true, label: this.$t('PatientFaS.PrimaryContactSSN'), class: 'text-rigth' },
              { key: 'primaryContactDOB', sortable: true, label: this.$t('PatientFaS.PrimaryContactDOB'), class: 'text-center' },
              { key: 'admitDate', sortable: true, label: this.$t('PatientFaS.AdmitDate'), class: 'text-center' },
              { key: 'admitTime', sortable: true, label: this.$t('PatientFaS.AdmitTime'), class: 'text-center' },
              { key: 'registrationDateTo', sortable: true, label: this.$t('PatientFaS.RegistrationDateTo'), class: 'text-center' },
              { key: 'programName', sortable: true, label: this.$tc('Shared.Program'), class: 'text-rigth' },
              { key: 'chartNo', sortable: true, label: this.$t('PatientFaS.ChartNo'), class: 'text-rigth' },
              { key: 'admissionType', sortable: true, label: this.$t('PatientFaS.AdmissionType'), class: 'text-center' },
              { key: 'status', sortable: true, label: this.$t('Shared.Status'), class: 'text-center' },
              { key: 'room', sortable: true, label: this.$tc('Shared.Room'), class: 'text-center' },
              { key: 'primaryInsuraceName', sortable: true, label: this.$t('PatientFaS.PrimaryInsuranceName'), class: 'text-rigth' },
              { key: 'primaryInsuraceAddress', sortable: true, label: this.$t('PatientFaS.PrimaryInsuranceAddress'), class: 'text-rigth' },
              { key: 'primaryInsuraceInsuredName', sortable: true, label: this.$t('PatientFaS.PrimaryInsuredName'), class: 'text-rigth' },
              { key: 'primaryInsuranceGroupName', sortable: true, label: this.$t('PatientFaS.PrimaryInsuranceGroup'), class: 'text-rigth' },
              { key: 'primaryInsurancePolicyNumber', sortable: true, label: this.$t('PatientFaS.PrimaryPolicyNumber'), class: 'text-rigth' },
              { key: 'primaryInsuracePhone', sortable: true, label: this.$t('PatientFaS.PrimaryInsurancePhone'), class: 'text-rigth' },
              { key: 'secondaryInsuraceName', sortable: true, label: this.$t('PatientFaS.SecondaryInsuranceName'), class: 'text-rigth' },
              { key: 'secondaryInsuraceAddress', sortable: true, label: this.$t('PatientFaS.SecondaryInsuranceAddress'), class: 'text-rigth' },
              { key: 'secondaryInsuraceInsuredName', sortable: true, label: this.$t('PatientFaS.SecondaryInsuredName'), class: 'text-rigth' },
              { key: 'secondaryInsuranceGroupName', sortable: true, label: this.$t('PatientFaS.SecondaryInsuranceGroup'), class: 'text-rigth' },
              { key: 'secondaryInsurancePolicyNumber', sortable: true, label: this.$t('PatientFaS.SecondaryPolicyNumber'), class: 'text-rigth' },
              { key: 'secondaryInsuracePhone', sortable: true, label: this.$t('PatientFaS.SecondaryInsurancePhone'), class: 'text-rigth' },
              { key: 'secPrimaryDiagnosis', sortable: true, label: this.$t('PatientFaS.SecondaryDiagnosis'), class: 'text-rigth' },
              { key: 'thirdPrimaryDiagnosis', sortable: true, label: this.$t('PatientFaS.ThirdDiagnosis'), class: 'text-rigth' }
          ],
          pageOptions: [5, 10, 15 ],
          totalRows: 0,
          currentPage: 1,
          perPage: 10,
          selected: [],
          Header:{},
          refTable: 'selectableTable', 
          ShowMessageIsEmpty:true,
        }
      },
      methods: {

      ChangeIsActive(item) {
        this.paramIsActive = item.value
      },

      onShowing(e) {
        let contentElement = e.component.content();
        let titleElement = e.component._$title[0]
        contentElement.style.padding = '0px';
        titleElement.style.padding = '0px 20px'
      },

      onHiddenReport() {
        this.isReportVisible = false
      },

      reportList() {
        this.checkExistFavorite('/app/reports/patients');
        this.$router.push({ name: "reportListPatient" }).catch(()=>{});
      },
      
      initializeParameters() {
        this.parameter.PatientCodeList = this.paramPatients && this.paramPatients !== ''
          ? this.paramPatients
          : null;
        this.parameter.ActivePatient = (this.paramIsActive === '') ? null : this.paramIsActive;
        this.parameter.IncludePhoto = false;
      },

      initializePdfParameters() {
        this.reportParams = []
        this.reportParams.push({ paramName: 'PatientCodeList', paramValue: this.paramPatients})
        this.reportParams.push({ paramName: 'ActivePatient', paramValue: this.paramIsActive})
      },

      onClickShowReport() {
        this.initializePdfParameters();
        this.isReportVisible = true
        this.$refs.PatientFaceSheetRep.buildDocument(this.reportParams)
      },


      getPatients(){ 
        this.$emit('load', true); 
        PatientService.getAll(this.fullParam)
        .then((response) => {
          if(response.status == '200' && response.data && response.data.length > 0) {
            this.$emit('load', false);
            this.PatientsOptions = response.data;                 
            this.PatientsOptions.forEach(function(element) {	
                element.patientname = element.firstname + " " + element.lastname + " - "+element.patientcode;   
            });       
          }       
        })
        .catch(error => {      
          if (!error.response) {
              // network error
              this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.retrieveInfo'),"error");
          } else {
              this.showMessage(this.$tc('Msg.Error'),error,"error");
          }
        });    
      },

      ChangePatients(item) {
        if(item != null){
          this.PatientModel = item;
          
          this.paramPatients = [];
          let selectedPatients = [];
          item.forEach(function(item) {   
            selectedPatients.push(item.patientcode);               
          });
          this.paramPatients = selectedPatients;
        }else{
          this.PatientModel = null;
        }
      },
      
      LoadPatientFaceSheet() {
          this.Loading = true;
          this.$emit('load', this.Loading);
          this.items = [];
          this.currentPage = 1;
          this.parameter.PageNumber = 1;
          this.totalRows = this.items.length;
          this.getPatientFaceSheet();
      },

      getPatientFaceSheet() {
        this.parameter.PageNumber = this.currentPage;
        this.parameter.PageSize = this.perPage;
        this.initializeParameters();
        
        PatientService
            .getPatientFaceSheet(this.parameter)
              .then(response => {
                if (response.status == "200" && response.data) {
                  this.items = response.data;

                  this.items.forEach(function(element) {
                    if (element.patientAcceptedDate)	
                      element.patientAcceptedDate = Utils.formatterDateToString(element.patientAcceptedDate); 
                    if (element.patientDOB)	
                      element.patientDOB = Utils.formatterDateToString(element.patientDOB); 
                    if (element.primaryContactDOB)	
                      element.primaryContactDOB = Utils.formatterDateToString(element.primaryContactDOB); 
                    if (element.admitDate)	
                      element.admitDate = Utils.formatterDateToString(element.admitDate); 
                    if (element.registrationDateTo)	
                      element.registrationDateTo = Utils.formatterDateToString(element.registrationDateTo); 
                    if (element.admitTime)	
                      element.admitTime = Utils.formatTimeHm(element.admitTime); 
                  });
                  let headerString = response.headers["x-pagination"];
                  this.Header = JSON.parse(headerString);
                  this.totalRows = this.Header.TotalCount;
                  this.showEmptyRecords = response.data && response.data.length == 0 ? true : false
                  this.$emit('showEmptyRecords', this.showEmptyRecords);
                }
                this.$emit('load', false);
            })
            .catch(error => {
                this.showResponseErrorMessage(error);
                this.$emit('load', false);
            });
      },  
      pageChanged (page) {            
        this.currentPage = page;
        this.getPatientFaceSheet();    
      },

      PerPageFunction(perpage){
        this.perPage = perpage;  
        this.currentPage = 1;
        this.getPatientFaceSheet();
      },

      handleCSV(action) {
        this.initializeParameters();
        switch(action) {
          case 'export':
            this.$refs.csvExportHelper.exportCSV(this.parameter);
          break;
          case 'email':
            this.$refs.csvExportHelper.emailCSV(this.parameter);
          break;
          default:
            console.warn('unknow action:', action);
          break;
        }
      },

      handlePdf(action) {
        this.initializePdfParameters();
        switch(action) {
          case 'export':
            this.$refs.csvExportHelper.exportToPdf('PatientFaceSheet', true, false, this.reportParams);
          break;
          case 'email':
            this.$refs.csvExportHelper.emailPdf('PatientFaceSheet', true, false, this.reportParams);
          break;
          default:
            console.warn('unknow action:', action);
          break;
        }
      },
    },

    async created(){
    },
    
    mounted () {
      this.getPatients();
      EventBus.$on("ShowWeel", function (isShow) { 
          isShow ? this.$emit('load', true) : this.$emit('load', false);     
      }.bind(this));
    },
  })
</script>
<style>
  .dxrd-report-preview-holder {  
      height: 94% !important; 
  } 
</style>
